import React, { lazy, Suspense } from "react";
import { ConfigProvider, Image } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import "./App.less";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import PageLoading from "./components/PageLoading";
import emptyIcon from "./assets/noempty/notable.png";

const AppLayout = lazy(() => import("./layouts/index"));
const LoginPage = lazy(() => import("./pages/login"));

const AntdConfig = {
  locale: zhCN,
};

const getToken = () => {
  const token = window.sessionStorage.getItem("token");
  return token;
};

const customizeRenderEmpty = () => (
  <div className="empty-class">
    <div className="img-icon"></div>
    <p>暂无数据</p>
  </div>
);

function App() {
  console.log(window.memberSysUrl);
  const isSwitch = new URL(window.location).searchParams.get("isSwitch");
  if (isSwitch === "YES") {
    const token = new URL(window.location).searchParams.get("token");
    window.sessionStorage.setItem("token", token);
  }
  return (
    <ConfigProvider {...AntdConfig} renderEmpty={customizeRenderEmpty}>
      <div className="App">
        <Router>
          <Suspense
            fallback={
              <div className="layout-loader">
                <PageLoading />
              </div>
            }
          >
            <Route
              exact
              path="/"
              render={() => {
                if (getToken()) {
                  if (window.location.pathname === "/") {
                    return <Redirect to="/app" />;
                  } else return <Redirect to={window.location.pathname} />;
                } else
                  return (window.location.href = `${window.memberSysUrl}/login`);
              }}
            />
            <Route path="/registration" component={LoginPage} />
            <Route path="/app" component={AppLayout} />
          </Suspense>
        </Router>
      </div>
    </ConfigProvider>
  );
}

export default App;
